"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _constants = require("../constants");
/**
 * @class MembersCollection
 */
var MembersCollection = /*#__PURE__*/function () {
  /**
   * @param {Object} locus
   * @memberof Members
   */
  function MembersCollection() {
    (0, _classCallCheck2.default)(this, MembersCollection);
    (0, _defineProperty2.default)(this, "members", void 0);
    (0, _defineProperty2.default)(this, "namespace", _constants.MEETINGS);
    this.members = {};
  }
  (0, _createClass2.default)(MembersCollection, [{
    key: "set",
    value: function set(id, member) {
      this.members[id] = member;
    }
  }, {
    key: "setAll",
    value: function setAll(members) {
      this.members = members;
    }

    /**
     * @param {String} id
     * @returns {Member}
     */
  }, {
    key: "get",
    value: function get(id) {
      return this.members[id];
    }

    /**
     * @returns {Object} returns an object map of Member instances
     * @memberof MembersCollection
     */
  }, {
    key: "getAll",
    value: function getAll() {
      return this.members;
    }
  }]);
  return MembersCollection;
}();
exports.default = MembersCollection;
//# sourceMappingURL=collection.js.map
